module.exports = __webpack_public_path__ + "assets/d7a23b9545fe6fe53da91b066523fc86.mp3";